import { render } from "./SaveElementModal.vue?vue&type=template&id=3971f3ff"
import script from "./SaveElementModal.vue?vue&type=script&lang=ts"
export * from "./SaveElementModal.vue?vue&type=script&lang=ts"

import "./SaveElementModal.vue?vue&type=style&index=0&id=3971f3ff&lang=scss"
script.render = render

export default script